module.exports = ( number, places ) => {
  number = number.toString();
  let length = number.toString().length;

  while( length < places ) {
    number = '0' + number;
    length += 1;
  }

  return number;
};



// WEBPACK FOOTER //
// ./src/utils/formatNum.js